import React, { useState, useEffect, useRef } from "react";
import { useBorrowerContext } from "../../../../../../store/borrower-details";
import axios from "axios";
import "./Obligations.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { url } from "../../../../../../../../../App";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Cookies from "js-cookie";
import DeleteIcon from "@mui/icons-material/Delete";
import Tooltip from "@mui/material/Tooltip";
import { IconButton } from "@mui/material";
import styles from "../../../Analysis/Components/VerificationNew/VerificationNew.module.css";
import EditIcon from '@mui/icons-material/Edit';
import MultiViewModal from "../../../../../../../../Loan/ViewLoanDetails/Components/MultiViewModal";
import { useParams } from "react-router-dom";

const Obligations = () => {
  const { loanid } = useParams();
  const loanId = loanid;
  const [open, setOpen] = React.useState(false);
  const token = Cookies.get("Token");
  const email = Cookies.get("Email");
  const { borrowerData } = useBorrowerContext();
  const fetchedLoanDetails = borrowerData.loan;
  const [borrowerName, setborrowerName] = useState("");
  const [product, setproduct] = useState("");
  const [loanCategory, setloanCategory] = useState("");
  const [financierName, setfinancierName] = useState("");
  const [dateofLoan, setdateofLoan] = useState("");
  const [loanAmount, setloanAmount] = useState("");
  const [emi, setemi] = useState("");
  const [loanType, setloanType] = useState("");
  const [RelationshipType, setRelationshipType] = useState("");
  const [reqArray, setReqArray] = useState([]);
  const [computeObligation, setComputeObligation] = useState(false);
  const [obligationId, setObligationId] = useState("");
  const [activeTab, setActiveTab] = useState("");
  const coapplicantDetails = borrowerData.coapplicant;
  const matchingcoapplicants = coapplicantDetails.filter((coapplicant) => coapplicant.coapplicant_loan_id === loanId);
  const numberOfCoapplicants = matchingcoapplicants.length;
  const matchingloans = fetchedLoanDetails.filter((loan) => loan.loan_id === loanId);
  const loanStatus = matchingloans[0]?.loan_status;
  const [borrowerObligation, setBorrowerObligation] = useState([]);
  const [coapplicantObligation1, setCoapplicantObligation1] = useState([]);
  const [coapplicantObligation2, setCoapplicantObligation2] = useState([]);
  const [coapplicantObligation3, setCoapplicantObligation3] = useState([]);
  const [coapplicantOtherObligation, setcoapplicantOtherObligation] = useState([]);
  const [loanDisbursed, setIsloanDisbursed] = useState(false);
  const [isUpdateActive, setIsUpdateActive] = useState(false);
  const [remarksValue, setRemarksValue] = useState("");
  const [bureauSource, setBureauSource] = useState("");
  const [ownership, setOwnership] = useState("");
  const [repaymentTenure, setRepaymentTenure] = useState("");
  const [paidTenure, setPaidTenure] = useState("");
  const [remainingTenure, setRemainingTenure] = useState("");
  const [soaVal, setSoaVal] = useState({
    soaImages: [],
  });
  const [parentModal, setParentModal] = useState(false);
  const [soaData, setSoaData] = useState([]);
  const [visible, setvisible] = useState(false);
  const [addObligation, setAddObligation] = useState(false);
  const [editObligation, setEditObligation] = useState(false);
  const [deleteObligation, setDeleteObligation] = useState(false);

  useEffect(() => {
    if (email === "rupesh.bishnoi@credin.in") {
      setvisible(true);
    } else {
      axios
        .post(url + "/user/getsingle", {
          token: token,
          email: email,
          useremail: email
        })
        .then((res) => {
          setAddObligation(res.data[0]?.permission.add_obligations_cam)
          setEditObligation(res.data[0]?.permission.edit_obligations_cam)
          setDeleteObligation(res.data[0]?.permission.delete_obligations_cam)
        })
        .catch((err) => {
          console.log(err);
        })
    };

  }, [email, token]);

  useEffect(() => {
    if (loanStatus === "DISBURSED") {
      setIsloanDisbursed(false);
    } else {
      setIsloanDisbursed(true);
    }
  }, [loanStatus]);

  useEffect(() => {
    if (repaymentTenure !== '' && paidTenure !== '') {
      const result = Number(repaymentTenure) - Number(paidTenure);
      setRemainingTenure(result >= 0 ? result : 0);
    } else {
      setRemainingTenure('');
    }
  }, [repaymentTenure, paidTenure]);

  const handleData = (obligationData) => {
    setActiveTab(obligationData)
    setOpen(true);

    axios
      .post(url + "/cam/get/cam/data", {
        token: token,
        email: email,
        loanId: loanId
      })
      .then((res) => {
        console.log(res.data);
        // console.log(obligationData);
        // console.log(activeTab);
        setReqArray("")
        setOpen(false);

        if (res?.data?.borrower_obligation && obligationData === "App") {
          const filteredObligations = res.data.borrower_obligation.filter(
            (item) => item.accountStatus !== "Closed Account"
          );
          // setBorrowerObligation(res.data?.borrower_obligation);
          // setReqArray(res.data?.borrower_obligation);
          setBorrowerObligation(filteredObligations);
          setReqArray(filteredObligations);
        }

        if (res?.data?.coborrower_obligation_1 && obligationData === "Coapp1") {
          const filteredObligations1 = res.data.coborrower_obligation_1.filter(
            (item) => item.accountStatus !== "Closed Account"
          );
          // setCoapplicantObligation1(res.data?.coborrower_obligation_1);
          // setReqArray(res.data?.coborrower_obligation_1);
          setCoapplicantObligation1(filteredObligations1);
          setReqArray(filteredObligations1);
        }

        if (res?.data?.coborrower_obligation_2 && obligationData === "Coapp2") {
          const filteredObligations2 = res.data.coborrower_obligation_2.filter(
            (item) => item.accountStatus !== "Closed Account"
          );
          // setCoapplicantObligation2(res.data?.coborrower_obligation_2);
          // setReqArray(res.data?.coborrower_obligation_2);
          setCoapplicantObligation2(filteredObligations2);
          setReqArray(filteredObligations2);
        }

        if (res?.data?.coborrower_obligation_3 && obligationData === "Coapp3") {
          const filteredObligations3 = res.data.coborrower_obligation_3.filter(
            (item) => item.accountStatus !== "Closed Account"
          );
          // setCoapplicantObligation3(res.data?.coborrower_obligation_3);
          // setReqArray(res.data?.coborrower_obligation_3);
          setCoapplicantObligation3(filteredObligations3);
          setReqArray(filteredObligations3);
        }
        if (res?.data?.coborrower_other_obligation && obligationData === "Others") {
          const Others = res.data.coborrower_other_obligation.filter(
            (item) => item.accountStatus !== "Closed Account"
          );
          setcoapplicantOtherObligation(Others);
          setReqArray(Others);
        }

      })
      .catch((err) => {
        console.log(err);
        setOpen(false);
      });
  };
  const handleAddData = async (e) => {
    e.preventDefault();
    setOpen(true);
    if (
      !borrowerName ||
      !product ||
      !loanCategory ||
      !financierName ||
      !dateofLoan ||
      !loanAmount ||
      !emi ||
      !loanType ||
      !bureauSource ||
      !ownership ||
      !repaymentTenure ||
      !paidTenure ||
      !remainingTenure
    ) {
      toast.error("Please fill all mandatory fields.");
      setOpen(false);
      return;
    }

    let newData = {
      obligation_id: Date.now().toString(),
      borrowerName,
      product,
      loanCategory,
      financierName,
      dateofLoan,
      loanAmount,
      emi,
      loanType,
      computeObligation,
      remarksValue,
      bureauSource,
      ownership,
      repaymentTenure,
      paidTenure,
      remainingTenure,
      created_at: new Date(),
      created_by: email,
      soaImages: soaVal.soaImages,
    };
    if (RelationshipType) {
      newData.relationship = RelationshipType
    }

    let updatedBorrowerObligation = [...borrowerObligation];
    let updatedCoapplicantObligation1 = [...coapplicantObligation1];
    let updatedCoapplicantObligation2 = [...coapplicantObligation2];
    let updatedCoapplicantObligation3 = [...coapplicantObligation3];
    let updatedCoapplicantOtherObligation = [...coapplicantOtherObligation];

    if (activeTab === "App") {
      updatedBorrowerObligation.push(newData);
    }
    if (activeTab === "Coapp1") {
      updatedCoapplicantObligation1.push(newData);
    }
    if (activeTab === "Coapp2") {
      updatedCoapplicantObligation2.push(newData);
    }
    if (activeTab === "Coapp3") {
      updatedCoapplicantObligation3.push(newData);
    }
    if (activeTab === "Others") {
      updatedCoapplicantOtherObligation.push(newData);
    }

    const payload = {
      token,
      email,
      loanId,
    };

    if (updatedBorrowerObligation.length > 0) {
      payload.borrower_obligation = updatedBorrowerObligation;
    }
    if (updatedCoapplicantObligation1.length > 0) {
      payload.coborrower_obligation_1 = updatedCoapplicantObligation1;
    }
    if (updatedCoapplicantObligation2.length > 0) {
      payload.coborrower_obligation_2 = updatedCoapplicantObligation2;
    }
    if (updatedCoapplicantObligation3.length > 0) {
      payload.coborrower_obligation_3 = updatedCoapplicantObligation3;
    }
    if (updatedCoapplicantOtherObligation.length > 0) {
      payload.coborrower_other_obligation = updatedCoapplicantOtherObligation;
    }

    try {


      console.log("payload-> ", payload)
      const response = await axios.post(`${url}/cam/add/obligation/data`, payload);

      if (activeTab === "App") {
        setBorrowerObligation(updatedBorrowerObligation);
        // setReqArray(updatedBorrowerObligation)
      }
      if (activeTab === "Coapp1") {
        setCoapplicantObligation1(updatedCoapplicantObligation1);
        // setReqArray(updatedCoapplicantObligation1)
      }
      if (activeTab === "Coapp2") {
        setCoapplicantObligation2(updatedCoapplicantObligation2);
        // setReqArray(updatedCoapplicantObligation2)
      }
      if (activeTab === "Coapp3") {
        setCoapplicantObligation3(updatedCoapplicantObligation3);
        // setReqArray(updatedCoapplicantObligation3)
      }
      if (activeTab === "Others") {
        setcoapplicantOtherObligation(updatedCoapplicantOtherObligation);
        // setReqArray(updatedCoapplicantObligation3)
      }
      setborrowerName("");
      setproduct("");
      setloanCategory("");
      setfinancierName("");
      setdateofLoan("");
      setloanAmount("");
      setemi("");
      setloanType("");
      setRelationshipType("");
      setComputeObligation(false);
      setRemarksValue("");
      setBureauSource("");
      setOwnership("");
      setRepaymentTenure("");
      setPaidTenure("");
      setRemainingTenure("");
      setSoaVal({
        soaImages: [],
      });
      setOpen(false);
      toast.success(response.data.message);
      fetchUpdatedData()
    } catch (err) {
      setOpen(false);
      toast.error(err.response?.data?.message);
      console.error(err);
    }
  };

  const handleDeleteRow = (obligationId) => {
    setOpen(true);
    const confirmObligation = window.confirm("Do you want to Delete the Obligation Data?");
    if (confirmObligation) {
      // console.log(obligationId)
      axios
        .post(url + "/cam/delete/obligation/data", {
          token: token,
          email: email,
          loanId: loanId,
          obligation_id: obligationId,
        })
        .then((res) => {
          setOpen(false);
          toast.success(res.data.message);
          fetchUpdatedData();
        })
        .catch((err) => {
          console.log(err);
          setOpen(false);
          toast.error(err.response.data.message);
        });
    } else {
      setOpen(false);
      toast.error("Obligation not Deleted.");
    }
  };

  const fetchUpdatedData = () => {
    console.log(activeTab);
    axios
      .post(url + "/cam/get/cam/data", {
        token: token,
        email: email,
        loanId: loanId,
      })
      .then((res) => {
        console.log(res.data);
        setOpen(false);
        setReqArray("");

        if (res?.data?.borrower_obligation && activeTab === "App") {
          const filteredObligations = res.data.borrower_obligation.filter(
            (item) => item.accountStatus !== "Closed Account"
          );
          // setBorrowerObligation(res.data?.borrower_obligation);
          // setReqArray(res.data?.borrower_obligation);
          setBorrowerObligation(filteredObligations);
          setReqArray(filteredObligations);
        }

        if (res?.data?.coborrower_obligation_1 && activeTab === "Coapp1") {
          const filteredObligations1 = res.data.coborrower_obligation_1.filter(
            (item) => item.accountStatus !== "Closed Account"
          );
          // setCoapplicantObligation1(res.data?.coborrower_obligation_1);
          // setReqArray(res.data?.coborrower_obligation_1);
          setCoapplicantObligation1(filteredObligations1);
          setReqArray(filteredObligations1);
        }

        if (res?.data?.coborrower_obligation_2 && activeTab === "Coapp2") {
          const filteredObligations2 = res.data.coborrower_obligation_2.filter(
            (item) => item.accountStatus !== "Closed Account"
          );
          // setCoapplicantObligation2(res.data?.coborrower_obligation_2);
          // setReqArray(res.data?.coborrower_obligation_2);
          setCoapplicantObligation2(filteredObligations2);
          setReqArray(filteredObligations2);
        }

        if (res?.data?.coborrower_obligation_3 && activeTab === "Coapp3") {
          const filteredObligations3 = res.data.coborrower_obligation_2.filter(
            (item) => item.accountStatus !== "Closed Account"
          );
          // setCoapplicantObligation3(res.data?.coborrower_obligation_3);
          // setReqArray(res.data?.coborrower_obligation_3);
          setCoapplicantObligation3(filteredObligations3);
          setReqArray(filteredObligations3);
        }
        if (res?.data?.coborrower_other_obligation && activeTab === "Others") {
          const coborrower_other_obligation = res.data.coborrower_other_obligation.filter(
            (item) => item.accountStatus !== "Closed Account"
          );
          // setCoapplicantObligation3(res.data?.coborrower_obligation_3);
          // setReqArray(res.data?.coborrower_obligation_3);
          setCoapplicantObligation3(coborrower_other_obligation);
          setReqArray(coborrower_other_obligation);
        }


      })
      .catch((err) => {
        console.log(err);
        setOpen(false);
      });
  };

  const handleEditRow = async (item) => {
    // console.log(item);
    setIsUpdateActive(true);
    setproduct(item.product);
    setloanCategory(item.loanCategory);
    setfinancierName(item.financierName);
    setdateofLoan(item.dateofLoan);
    setloanAmount(item.loanAmount);
    setemi(item.emi);
    setloanType(item.loanType);
    setRelationshipType(item?.relationship);
    setObligationId(item.obligation_id);
    setComputeObligation(item.computeObligation);
    setRemarksValue(item.remarksValue);
    setBureauSource(item.bureauSource);
    setOwnership(item.ownership);
    setRepaymentTenure(item.repaymentTenure);
    setPaidTenure(item.paidTenure);
    setRemainingTenure(item.remainingTenure);
    setborrowerName(item.borrowerName)
    setSoaVal({
      soaImages: [],
    });
  };

  const updateObligation = async (e) => {
    e.preventDefault();
    // console.log(activeTab);
    let field = "";
    if (activeTab === "App") field = "borrower_obligation";
    if (activeTab === "Coapp1") field = "coborrower_obligation_1";
    if (activeTab === "Coapp2") field = "coborrower_obligation_2";
    if (activeTab === "Coapp3") field = "coborrower_obligation_3";
    if (activeTab === "Others") field = "coborrower_other_obligation";

    if (!field) {
      toast.error('Invalid obligation type');
      return;
    }
    try {
      const response = await axios.put(url + '/cam/update-obligation', {
        loanId: loanId,
        token: token,
        email: email,
        obligation_id: obligationId,
        field: field,
        updatedData: {
          obligation_id: obligationId,
          product: product,
          loanCategory: loanCategory,
          financierName: financierName,
          dateofLoan: dateofLoan,
          loanAmount: loanAmount,
          emi: emi,
          loanType: loanType,
          computeObligation: computeObligation,
          remarksValue,
          bureauSource,
          ownership,
          repaymentTenure,
          paidTenure,
          remainingTenure,
          created_at: new Date(),
          created_by: email,
          soaImages: soaVal.soaImages,
          relationship: RelationshipType ? RelationshipType :null
        }
      });
      toast.success(response.data.message);
      fetchUpdatedData();
      setproduct("");
      setloanCategory("");
      setfinancierName("");
      setdateofLoan("");
      setloanAmount("");
      setemi("");
      setloanType("");
      setRelationshipType("");
      setborrowerName("");
      setComputeObligation("");
      setRemarksValue("");
      setBureauSource("");
      setOwnership("");
      setRepaymentTenure("");
      setPaidTenure("");
      setRemainingTenure("");
      setSoaVal({
        soaImages: [],
      });
      setIsUpdateActive(false);
      fetchUpdatedData();
    } catch (error) {
      console.error('Error updating obligation:', error.response?.data || error.message);
      toast.error('Failed to update obligation');
    }
  };

  const soaRef = useRef(null);

  const handleUpload = (e, docType) => {
    console.log("reached")
    console.log(e)
    const files = e.target.files;
    if (!files || files.length === 0) {
      setOpen(false);
      return;
    }

    const soaFormat = ["pdf"];
    if (docType === "soa") {
      const newImages = [];
      const promises = Array.from(files).map((file) => {
        return new Promise((resolve, reject) => {
          const fileExtension = file.name.split(".").pop().toLowerCase();
          if (!soaFormat.includes(fileExtension)) {
            toast.error("Please upload SOA/NOC in pdf format only.");
            reject();
            return;
          }
          const reader = new FileReader();
          reader.onload = () => {
            const base64string = reader.result.split(",")[1];
            console.log(base64string)
            newImages.push({
              soaKey: base64string,
              soaDocType: fileExtension,
              soaDocId: Date.now().toString()
            });
            resolve();
          };
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });
      });

      Promise.all(promises)
        .then(() => {
          setSoaVal((prevState) => ({
            ...prevState,
            soaImages: [...prevState.soaImages, ...newImages],
          }));
          toast.success("SOA/NOC Documents Uploaded Successfully.");
        })
        .catch(() => {
          setOpen(false);
        });
    }
  };

  const handleMultiDocs = async (data) => {
    setParentModal(true)
    setSoaData(data)
  }

  const onDelete = async (file) => {
    console.log(activeTab)
    let userType = "";
    if (activeTab === "App") userType = "borrower_obligation";
    if (activeTab === "Coapp1") userType = "coborrower_obligation_1";
    if (activeTab === "Coapp2") userType = "coborrower_obligation_2";
    if (activeTab === "Coapp3") userType = "coborrower_obligation_3";

    // console.log(file,"delete")
    const confirmDelete = window.confirm("Do you want to Delete the SOA/NOC Image?");
    if (!confirmDelete) {
      toast.error("Permission Denied by the user.");
      return false;
    }

    if (!userType) {
      toast.error('Invalid obligation type');
      return;
    }

    try {
      const response = await axios.post(url + "/cam/deleteSoaImages", {
        imageId: file.soaDocId,
        loanId: loanId,
        userType: userType,
        token: Cookies.get("Token"),
        email: Cookies.get("Email"),
      });

      if (response.data.auth) {
        toast.success(response.data.message);
        return true;
      } else {
        toast.error("Unauthorized or deletion failed.");
        return false;
      }
    } catch (error) {
      console.error("Error deleting document:", error);
      toast.error("Failed to delete document.");
      return false;
    }
  };
  useEffect(() => {
    setborrowerName("");
    setproduct("");
    setloanCategory("");
    setfinancierName("");
    setdateofLoan("");
    setloanAmount("");
    setemi("");
    setloanType("");
    setRelationshipType("");
    setComputeObligation(false);
    setRemarksValue("");
    setBureauSource("");
    setOwnership("");
    setRepaymentTenure("");
    setPaidTenure("");
    setRemainingTenure("");
  }, [activeTab])

  return (
    <div className="obligation-form">
      <form>
        {loanId && (
          <div>
            <button
              type="button"
              className={styles.addhoverButton}
              onClick={() => handleData("App")}
              style={{
                backgroundColor: activeTab === "App" ? "#034ea1" : "#eef7ff",
                color: activeTab === "App" ? "white" : "gray",
              }}>
              Applicant
            </button>

            {numberOfCoapplicants > 0 && (
              <button
                type="button"
                className={styles.addhoverButton}
                onClick={() => handleData("Coapp1")}
                style={{
                  backgroundColor: activeTab === "Coapp1" ? "#034ea1" : "#eef7ff",
                  color: activeTab === "Coapp1" ? "white" : "gray",
                }}>
                Co-Applicant 1
              </button>
            )}

            {numberOfCoapplicants > 1 && (
              <button
                type="button"
                className={styles.addhoverButton}
                onClick={() => handleData("Coapp2")}
                style={{
                  backgroundColor: activeTab === "Coapp2" ? "#034ea1" : "#eef7ff",
                  color: activeTab === "Coapp2" ? "white" : "gray",
                }}>
                Co-Applicant 2
              </button>
            )}

            {numberOfCoapplicants > 2 && (
              <button
                type="button"
                className={styles.addhoverButton}
                onClick={() => handleData("Coapp3")}
                style={{
                  backgroundColor: activeTab === "Coapp3" ? "#034ea1" : "#eef7ff",
                  color: activeTab === "Coapp3" ? "white" : "gray",
                }}>
                Co-Applicant 3
              </button>
            )}
            {(
              <button
                type="button"
                className={styles.addhoverButton}
                onClick={() => handleData("Others")}
                style={{
                  backgroundColor: activeTab === "Others" ? "#034ea1" : "#eef7ff",
                  color: activeTab === "Others" ? "white" : "gray",
                }}>
                Others
              </button>
            )}
          </div>
        )}

        {(activeTab === "App" || activeTab === "Coapp1" || activeTab === "Coapp2" || activeTab === "Coapp3" || activeTab === "Others") && (
          <>
            <div className="wrapper-loan-product">
              <div className="nbfc-fields">
              <label>
                  {activeTab === "App"
                    ? "Borrower Name*"
                    : activeTab === "Others"
                    ? "Name*"
                    : "Coapplicant Name*"}
                </label>
                <br />
                <input
                  type="text"
                  onChange={(e) => {
                    setborrowerName(e.target.value);
                  }}
                  disabled={!loanDisbursed}
                  value={borrowerName}
                  required
                  className="inp-loan-product"
                ></input>
              </div>
              <div className="nbfc-fields">
                <label className="product-text" style={{ display: "block" }}>Product*</label>
                <input
                  type="text"
                  onChange={(e) => {
                    setproduct(e.target.value);
                  }}
                  disabled={!loanDisbursed}
                  value={product}
                  required
                  className="inp-loan-product"
                ></input>
              </div>
              {activeTab === "Others" && (<div className="nbfc-fields">
                <label className="product-text">Relationships *</label>
                <select
                  className="inp-loan-product"
                  onChange={(e) => { setRelationshipType(e.target.value) }}
                  value={RelationshipType}
                  required
                  disabled={!loanDisbursed}
                >
                  <option value="">Select </option>
                  <option value="Brother">Brother</option>
                  <option value="Sister">Sister</option>
                  <option value="Father">Father</option>
                  <option value="Mother">Mother</option>
                  <option value="Son">Son</option>
                  <option value="Daughter">Daughter</option>
                  <option value="Spouse">Spouse</option>
                </select>
              </div>)}
              <div className="nbfc-fields">
                <label className="product-text">Loan Category*</label>
                <select
                  className="inp-loan-product"
                  onChange={(e) => { setloanCategory(e.target.value) }}
                  value={loanCategory}
                  required
                  disabled={!loanDisbursed}
                >
                  <option value="">Select </option>
                  <option value="Agri">Agri</option>
                  <option value="Non Agri">Non Agri</option>
                </select>
              </div>

              <div className="nbfc-fields">
                <label className="product-text">Financier Name*</label>
                <input
                  type="text"
                  onChange={(e) => {
                    setfinancierName(e.target.value);
                  }}
                  disabled={!loanDisbursed}
                  value={financierName}
                  required
                  className="inp-loan-product"
                ></input>
              </div>
              <div className="nbfc-fields">
                <label className="product-text">Date of Loan*</label>
                <input
                  type="date"
                  onChange={(e) => {
                    setdateofLoan(e.target.value);
                  }}
                  disabled={!loanDisbursed}
                  value={dateofLoan}
                  required
                  className="inp-loan-product"
                  inputProps={{
                        max: new Date().toISOString().split("T")[0],
                  }}
                ></input>
              </div>
              <div className="nbfc-fields">
                <label className="product-text">Loan Amount*</label>
                <input
                  type="number"
                  onChange={(e) => {
                    setloanAmount(e.target.value);
                  }}
                  disabled={!loanDisbursed}
                  required
                  value={loanAmount}
                  className="inp-loan-product"
                ></input>
              </div>
              <div className="nbfc-fields">
                <label className="product-text">Emi*</label>
                <br></br>
                <input
                  type="number"
                  required
                  onChange={(e) => {
                    setemi(e.target.value);
                  }}
                  disabled={!loanDisbursed}
                  value={emi}
                  className="inp-loan-product"
                ></input>
              </div>
              <div className="nbfc-fields">
                <label className="product-text">Loan Type*</label>
                <select
                  className="inp-loan-product"
                  onChange={(e) => { setloanType(e.target.value) }}
                  value={loanType}
                  required
                  disabled={!loanDisbursed}
                >
                  <option value="">Select </option>
                  <option value="Unsecured">Unsecured</option>
                  <option value="Secured">Secured</option>
                </select>
              </div>

              <div className="nbfc-fields">
                <label className="product-text">Credit Bureau Source*</label>
                <select
                  className="inp-loan-product"
                  onChange={(e) => { setBureauSource(e.target.value) }}
                  value={bureauSource}
                  required
                  disabled={!loanDisbursed}
                >
                  <option value="">Select </option>
                  <option value="CRIF">CRIF</option>
                  <option value="CIBIL">CIBIL</option>
                  <option value="EQUIFAX">EQUIFAX</option>
                  <option value="Bank Statement">Bank Statement</option>
                  <option value="Customer">Customer</option>
                </select>
              </div>

              <div className="nbfc-fields">
                <label className="product-text">Ownership*</label>
                <select
                  className="inp-loan-product"
                  onChange={(e) => { setOwnership(e.target.value) }}
                  value={ownership}
                  required
                  disabled={!loanDisbursed}
                >
                  <option value="">Select </option>
                  <option value="Individual">Individual</option>
                  <option value="Primary">Primary</option>
                  <option value="Joint">Joint</option>
                  <option value="Guarantor">Guarantor</option>
                </select>
              </div>

              <div className="nbfc-fields">
                <label className="product-text">Repayment Tenure(in Months)*</label>
                <input
                  type="number"
                  required
                  onChange={(e) => {
                    setRepaymentTenure(e.target.value);
                  }}
                  disabled={!loanDisbursed}
                  value={repaymentTenure}
                  className="inp-loan-product"
                ></input>
              </div>
              <div className="nbfc-fields">
                <label className="product-text">Paid Tenure(in Months)*</label>
                <input
                  type="number"
                  required
                  onChange={(e) => {
                    setPaidTenure(e.target.value);
                  }}
                  disabled={!loanDisbursed}
                  value={paidTenure}
                  className="inp-loan-product"
                ></input>
              </div>
              <div className="nbfc-fields">
                <label className="product-text">Remaining Tenure(in Months)*</label>
                <input
                  type="number"
                  required
                  disabled
                  value={remainingTenure}
                  className="inp-loan-product"
                ></input>
              </div>
              <div className="nbfc-fields">
                <label className="product-text">SOA/NOC</label>
                <input
                  onChange={(e) => handleUpload(e, "soa")}
                  type="file"
                  ref={soaRef}
                  style={{ display: "none" }}
                  multiple
                  disabled={!loanDisbursed}
                />
                <button
                  type="button"
                  className="obg-btn"
                  onClick={() => {
                    soaRef.current.value = null;
                    soaRef.current.click();
                  }}
                  disabled={!loanDisbursed}
                >
                  {isUpdateActive ? "Upload New Doc" : "Upload"}
                </button>
              </div>

              <div className="product-text">
                <input
                  type="checkbox"
                  onChange={(e) => setComputeObligation(e.target.checked)}
                  checked={computeObligation}
                  disabled={!loanDisbursed}
                />
                <label style={{ marginLeft: ".5rem" }}>
                  Compute the Obligation
                </label>
              </div>

              <div className="nbfc-fields">
                <label className="product-text">Remarks</label>
                <textarea
                  name="description"
                  id="description"
                  cols="50"
                  rows="5"
                  value={remarksValue}
                  className="inp-loan-product"
                  onChange={(e) => setRemarksValue(e.target.value)}
                  placeholder="Type your message here..."
                  disabled={!loanDisbursed}
                ></textarea>
              </div>
              {(addObligation || visible) && (
                <div className="nbfc-fields">
                  <button
                    type="submit"
                    onClick={isUpdateActive ? updateObligation : handleAddData}
                    className="obg-btn"
                    disabled={!loanDisbursed}
                  >
                    {isUpdateActive ? "Update" : "Add"}
                  </button>
                </div>
              )}
            </div>

            <div className="obligations-container">
              <table className="report-table1">
                <thead style={{backgroundColor:'rgb(207, 226, 243)'}}>
                  <tr>
                    <th style={{border:'1px solid black'}}>Name</th>
                    {activeTab === "Others" ? <th style={{border:'1px solid black'}}>Relationship</th> : <></>}
                    <th style={{border:'1px solid black'}}>Product</th>
                    <th style={{border:'1px solid black'}}>Loan Category</th>
                    <th style={{border:'1px solid black'}}>Financier Name</th>
                    <th style={{border:'1px solid black'}}>Date of Loan</th>
                    <th style={{border:'1px solid black'}}>Loan Amt</th>
                    <th style={{border:'1px solid black'}}>Emi</th>
                    <th style={{border:'1px solid black'}}>Loan Type</th>
                    <th style={{border:'1px solid black'}}>Credit Bureau Source</th>
                    <th style={{border:'1px solid black'}}>Ownership</th>
                    <th style={{border:'1px solid black'}}>Repayment Tenure</th>
                    <th style={{border:'1px solid black'}}>Paid Tenure</th>
                    <th style={{border:'1px solid black'}}>Remaining Tenure</th>
                    <th style={{border:'1px solid black'}}>View SOA/NOC</th>
                    <th style={{border:'1px solid black'}}>Compute the obligation</th>
                    {(editObligation || deleteObligation || visible) && (
                      <th style={{ border: '1px solid black' }}>Action</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {reqArray?.length > 0 && reqArray?.map((item, index) => {
                    // console.log(item);
                    return (
                      <tr key={item.obligation_id}>
                        <td style={{border:'1px solid black'}}>{item.borrowerName}</td>
                        {activeTab === "Others" ? <td style={{border:'1px solid black'}}>{item?.relationship}</td> : <></>}
                        <td style={{border:'1px solid black'}}>{item.product}</td>
                        <td style={{border:'1px solid black'}}>{item.loanCategory}</td>
                        <td style={{border:'1px solid black'}}>{item.financierName}</td>
                        <td style={{border:'1px solid black'}}>{item.dateofLoan}</td>
                        <td style={{border:'1px solid black'}}>{item.loanAmount}</td>
                        <td style={{border:'1px solid black'}}>{item.emi}</td>
                        <td style={{border:'1px solid black'}}>{item.loanType}</td>
                        <td style={{border:'1px solid black'}}>{item.bureauSource}</td>
                        <td style={{border:'1px solid black'}}>{item.ownership}</td>
                        <td style={{border:'1px solid black'}}>{item.repaymentTenure}</td>
                        <td style={{border:'1px solid black'}}>{item.paidTenure}</td>
                        <td style={{border:'1px solid black'}}>{item.remainingTenure}</td>
                        <td style={{border:'1px solid black'}}>
                          <div className="product-text">
                            {item.soaImages && item.soaImages.length > 0 ? (
                              <Tooltip title="View Document">
                                <button
                                  type="button"
                                  className="obg-btn"
                                  onClick={() => handleMultiDocs(item.soaImages)}
                                >
                                  View
                                </button>
                              </Tooltip>
                            ) : (
                              <span style={{ color: 'gray', fontStyle: 'italic' }}>
                                No Document Found
                              </span>
                            )}
                          </div>

                        </td>
                        <td style={{border:'1px solid black'}}>{item?.computeObligation?.toString()}</td>
                        {(editObligation || deleteObligation || visible) && (
                          <td style={{ border: '1px solid black' }}>
                            {(editObligation || visible) && (
                              <Tooltip title="Edit Obligation">
                                <IconButton
                                  onClick={(e) => handleEditRow(item)}
                                  disabled={!loanDisbursed}
                                >
                                  <EditIcon sx={{ color: loanDisbursed ? "red" : "gray" }} />
                                </IconButton>
                              </Tooltip>
                            )}

                            {(deleteObligation || visible) && (
                              <Tooltip title="Delete Obligation">
                                <IconButton
                                  onClick={(e) => handleDeleteRow(item.obligation_id)}
                                  disabled={!loanDisbursed}
                                >
                                  <DeleteIcon sx={{ color: loanDisbursed ? "red" : "gray" }} />
                                </IconButton>
                              </Tooltip>
                            )}
                          </td>
                        )}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </>
        )}
      </form>
      <ToastContainer />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <MultiViewModal
        open={parentModal}
        data={soaData}
        close={() => setParentModal(false)}
        loanId={loanId}
        onDelete={onDelete}
        dbKey="soaKey"
        dbDocType="soaDocType"
        docName="Soa"
      />
    </div>
  );
};

export default Obligations;
